export default class BingoWS {
  public onclose?: () => void;

  private endpoint: string;

  private ws?: WebSocket;

  constructor(host: string) {
    const protocol = host.startsWith("localhost") ? "ws" : "wss";
    this.endpoint = `${protocol}://${host}/api/bingo_ws`;
  }

  public open(): Promise<BingoWS> {
    this.close();
    return new Promise((resolve) => {
      this.ws = new WebSocket(this.endpoint);
      this.ws.onmessage = (event) => {
        const msg = JSON.parse(event.data);
        console.log(msg);
        // switch (msg.e) {
        //   case "stdout":
        //   case "stderr":
        //     this.sender.trackTestOutput(msg.e, msg.data.l);
        //     break;
        //   case "cmd_done":
        //     this.sender.trackTestDone();
        //     this.close();
        //     break;
        // }
      };
      this.ws.onopen = () => {
        resolve(this);
      };
      this.ws.onclose = () => {
        if (this.onclose) {
          this.onclose();
        }
      };
    });
  }

  public ping() {
    if (this.ws) {
      this.ws.send(JSON.stringify({ e: "ping" }));
    }
  }

  // public validate() {
  //   if (this.ws) {
  //     this.ws.send(JSON.stringify({e: "validate"}));
  //   }
  // }

  // public generateOutput(files: any, content: string, language: ProgrammingLanguage) {
  //   if (this.ws) {
  //     this.ws.send(JSON.stringify({
  //       e: "generateOutput",
  //       files,
  //       content,
  //       language,
  //     }));
  //   }
  // }

  public close() {
    if (this.ws) {
      this.ws.close();
    }
    this.ws = undefined;
  }

  public isRunning() {
    return Boolean(this.ws);
  }
}
